import { FoodItem, cartItem } from "../../types";
import { 
  fetchAllData, 
} from "../Firebase";

import { MdShoppingBasket } from "react-icons/md";
import { toast } from "react-toastify";

export const addToCart = async (
  cartItems: cartItem[],
  foodItems: FoodItem[], 
  fid: number,
  dispatch: any
) => {
  // } else {
  if (cartItems.some((item: cartItem) => item["fid"] === fid)) {
    toast.error("Item already in cart", {
      icon: <MdShoppingBasket className="text-2xl text-cartNumBg" />,
      toastId: "itemAlreadyInCart",
    });
  } else {
    const foodItem = getFoodyById(foodItems, fid);
    const minqty = foodItem?.minqty || 1;

    toast.success("Item added to cart", {
      icon: <MdShoppingBasket className="text-2xl text-cartNumBg" />,
      toastId: "unauthorizedAddToCart",
    });
    const data = {
      id: Date.now(),
      fid: fid, 
      qty: minqty,
    };
    dispatch({
      type: "SET_CARTITEMS",
      cartItems: [...cartItems, data],
    });
    calculateCartTotal(cartItems, foodItems, dispatch); 
  }
}
// };
export const dispatchtUserCartItems = (
  uid: string,
  items: cartItem[],
  dispatch: any
) => {
  const cartItems = items.filter((item: cartItem) => item.uid === uid);
  dispatch({
    type: "SET_CARTITEMS",
    cartItems: cartItems,
  });

  return cartItems;
}; 

export const fetchFoodData = async (dispatch: any) => {
  await fetchAllData()
    .then((data) => { 
      dispatch({
        type: "SET_DELIVERY_FEES",
        deliveryFees: data.deliveryFees,
      });
      dispatch({
        type: "SET_FOOD_ITEMS",
        foodItems: data.products,
      });
      dispatch({
        type: "SET_PRODUCTS",
        products: data.products,
      });
      dispatch({
        type: "SET_CATEGORIES",
        categories: data.categories,
      });
      dispatch({
        type: "SET_SECTIONS",
        sections: data.sections,
      });
    })
    .then(() => { })
    .catch((e) => {
      console.log(e);
    });
};

export const getFoodyById = (menu: FoodItem[], fid: number) => {
  return menu.find((item: FoodItem) => item.id === fid);
};

//  Update cart item State
export const updateCartItemState = async (
  cartItems: cartItem[],
  item: cartItem,
  dispatch: any
) => {
  const index = cartItems.findIndex(
    (cartItem: cartItem) => cartItem.id === item.id
  );
  if (index !== -1) {
    cartItems[index] = item;
  }
  dispatch({
    type: "SET_CARTITEMS",
    cartItems: cartItems,
  }); 
};

// Update Cart Item Quantity
// Respects minqty (minimum quantity) and increment constraints from food items
// - minqty: minimum quantity that can be ordered (default: 1)
// - increment: quantity increment step (default: 1)
export const updateCartItemQty = async (
  cartItems: cartItem[],
  foodItems: FoodItem[],
  item: cartItem,
  dispatch: any,
  val: number
) => {
  const index = cartItems.findIndex(
    (cartItem: cartItem) => cartItem.id === item.id
  );
  if (index !== -1) {
    const foodItem = getFoodyById(foodItems, item.fid);
    const minqty = foodItem?.minqty || 1;
    const increment = foodItem?.increment || 1;
    console.log("🚀 ~ updateCartItemQty ~ foodItem:", foodItem)
    
    // Calculate new quantity
    let newQty = cartItems[index].qty + val;
    
    // Ensure quantity doesn't go below minimum
    if (newQty < minqty) {
      newQty = minqty;
    }
    
    // Ensure quantity follows increment pattern
    if (increment > 1) {
      // Round to nearest increment
      const baseQty = Math.floor((newQty - minqty) / increment) * increment + minqty;
      newQty = baseQty;
    }
    
    cartItems[index].qty = newQty;
    dispatch({
      type: "SET_CARTITEMS",
      cartItems: cartItems,
    });
    calculateCartTotal(cartItems, foodItems, dispatch); 
  }
};

//  Delete Cart Item
export const deleteCartItem = async (
  cartItems: cartItem[],
  foodItems: FoodItem[],
  item: cartItem,
  dispatch: any
) => {
  const updatedCart = cartItems.filter(cartItem => cartItem.id !== item.id);

  dispatch({
    type: "SET_CARTITEMS",
    cartItems: updatedCart,
  });

  calculateCartTotal(updatedCart, foodItems, dispatch);
};

// Calculate Total Price Round to 2 decimal places
export const calculateCartTotal = (
  cartItems: cartItem[],
  foodItems: FoodItem[],
  dispatch: any
) => {
  let total = 0;
  cartItems.forEach((item: cartItem) => {
    const foodItem = getFoodyById(foodItems, item.fid);
    total += item.qty * parseFloat(foodItem?.price || "0");
  });
  dispatch({
    type: "SET_CART_TOTAL",
    cartTotal: total.toFixed(2),
  });
};

// Empty Cart
export const emptyCart = async (
  cartItems: cartItem[],
  foodItems: FoodItem[],
  dispatch: any
) => {
  if (cartItems.length > 0) {
    dispatch({
      type: "SET_CARTITEMS",
      cartItems: [],
    });
    calculateCartTotal(cartItems, foodItems, dispatch); 
  } else {
    toast.warn("Cart is already empty");
  }
};

// Hide Cart
export const hideCart = (dispatch: any) => {
  dispatch({
    type: "TOGGLE_CART",
    showCart: !true,
  });
};

// Hide Cart
export const hideContactform = (dispatch: any) => {
  dispatch({
    type: "TOGGLE_CONTACT_FORM",
    showContactForm: !true,
  });
};

export const shuffleItems = (items: any) => {
  let currentIndex = items.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [items[currentIndex], items[randomIndex]] = [
      items[randomIndex],
      items[currentIndex],
    ];
  }

  return items;
};
 

export const ToggleAdminMode = (dispatch: any, state: boolean) => {
  dispatch({
    type: "SET_ADMIN_MODE",
    adminMode: state,
  });
  localStorage.setItem("adminMode", JSON.stringify(state)); 
}; 
// delete food
export const deleteFood = async (
  food: FoodItem,
  foodItems: FoodItem[],
  dispatch: any
) => {
  // await firebaseDeleteFood(food.id);
  // remove food from foodItems
  const foodIndex = foodItems.indexOf(food);
  if (foodIndex !== -1) {
    foodItems.splice(foodIndex, 1)
  }
  dispatch({
    type: "SET_FOOD_ITEMS",
    foodItems
  })
  toast.success("Food deleted successfully");
};

